import { render, staticRenderFns } from "./AddNotesModal.vue?vue&type=template&id=5ac641aa&scoped=true&"
import script from "./AddNotesModal.vue?vue&type=script&lang=js&"
export * from "./AddNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNotesModal.vue?vue&type=style&index=0&id=5ac641aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac641aa",
  null
  
)

export default component.exports